import { FiGrid, FiList } from "react-icons/fi";
import { cn } from "utils/helpers";
import { ButtonViewGroupProps } from "./types";

const commonButtonStyle =
	"h-[40px] flex items-center justify-center px-3 border border-[#D0D5DD] transition-colors cursor-pointer";
const selectedStyle = "border-royal-blue bg-blue-50 text-royal-blue";
const unselectedStyle = "bg-white text-gray-500 hover:bg-gray-50";

export const ButtonViewGroup: React.FC<ButtonViewGroupProps> = ({
	setView,
	view,
	className,
}) => {
	return (
		<div className={cn("sm:hidden lg:flex", className)}>
			<button
				type="button"
				className={cn(
					commonButtonStyle,
					"rounded-l-md",
					view === "grid"
						? selectedStyle
						: unselectedStyle
				)}
				onClick={() => setView("grid")}
			>
				<FiGrid size={22} />
			</button>
			<button
				type="button"
				className={cn(
					commonButtonStyle,
					"-ml-px rounded-r-md",
					view === "list"
						? selectedStyle
						: unselectedStyle
				)}
				onClick={() => setView("list")}
			>
				<FiList size={22} />
			</button>
		</div>
	);
};

export default ButtonViewGroup;
